"use strict";

exports.__esModule = true;

var _from = require("../core-js/array/from");

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/~/babel-runtime/helpers/toArray.js
 ** module id = 220
 ** module chunks = 0
 **/